
import PromoList            from '@/components/frontOffice/PromoList.vue'
import PriceListUpdate      from '@/components/frontOffice/PriceListUpdate.vue'

const menuId = 'fo4'
const routes = [
    
    {
        path        : '/promo', 
        name        : 'promo',
        component   : PromoList,
        meta        : { name : 'Promo Saldi', visible : true ,icon : 'fas fa-business-time',menu:menuId,color:'#ff00ff'},   
    },
    {
        path        : '/priceListUpdate', 
        name        : 'priceListUpdate',
        component   : PriceListUpdate,
        meta        : { name : 'Aggiornamento Listino', visible : true ,icon : 'far fa-edit',menu:menuId,color:'#ff00ff'},   
    },
    
        
]
export default routes
